import { Component } from '@angular/core';
import { Subscription } from 'rxjs';
import { AuthService } from '@authentication/auth.service';
import { AccionLogin } from '@shared/enums/AccionLogin';
import { UsuarioService } from '@account/usuario.service';
import { TipoUsuario } from '@shared/enums/tipoUsuario';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.css']
})
export class WelcomeComponent  {

  enumAccionLogin = AccionLogin;
  accionLoginSubscription: Subscription;
  accionLogin: AccionLogin;

  username: string;
  nombreCompleto: string;
  email: string;
  dni: string;
  roles: string;

  TipoUsuario = TipoUsuario;

  constructor(public authService: AuthService, private usuarioService: UsuarioService) { 
    this.accionLoginSubscription = this.authService.authAccionLogin$.subscribe(accionLogin => {
      if(accionLogin != null) 
        this.accionLogin = accionLogin;
        this.username = usuarioService.getUsername();
        this.nombreCompleto = usuarioService.getNombresCompletosUsuario();
        //this.email = usuarioService.getEmailUsuario();
        this.dni = usuarioService.getDniUsuario();        
        this.roles = usuarioService.getMostrarRoles();
    });
  }

  obtenerNombreRoles(n:number) {
    return TipoUsuario[n]
  }

  onCerrarSesionClick() {
    this.authService.signout();
    location.assign("#");
  }

}
